import { Box, Fade, Grid, useMediaQuery } from '@mui/material';
import React, { forwardRef, useContext, useState } from 'react';
import { useEffect } from 'react';
import { AreaContext } from '../store/AreaContext';
import { SAVE_CURRENT_AREA } from '../store/AreaReducers';
import AreaBackground from './AreaBackground';
import FloatingCustom from './Floating_custom';
import FloatingResources from './Floating_resources';
import Hotspot from './Hotspot';
import HotspotButton from './Hotspot_button';
import PortraitAlert from './PortraitAlert';
import Timeline from './Timeline';
import { isMobile } from 'react-device-detect';
import FilterBar from './FilterBar';
import LanguageSelect from './LanguageSelect';
import OverviewButtons from './OverviewButtons';
import Header from './Header';

const Area = forwardRef(({ area, video_ref, handleVideoSnapshot, canvas, firstLoad, setFirstLoad, fixed, portrait }, ref) => {

	const { transition, dispatchCurrentArea } = useContext(AreaContext);
	const [isVisible, setIsVisible] = useState();
	const xlDown = useMediaQuery((theme) => theme.breakpoints.down('xl'));

	useEffect(() => {

		dispatchCurrentArea({
			type: SAVE_CURRENT_AREA,
			payload: {
				background: area.background,
				route: area.route,
				slug: area.slug,
				transition_out: area.transition_out || null,
				floating_buttons: area.floating_buttons || [],
				parent_area: area.parent_area
					? {
						...area.parent_area
					}
					: null
			}
		});
	}, [area, dispatchCurrentArea]);

	//when videos are playing hide other elements
	useEffect(() => {
		if (transition.play) {
			setIsVisible(false)
		} else {
			setIsVisible(true)
		}
	}, [transition])

	const splitLeft = (area) => {
		if (area.area_type[0].hotspot_left) {
			let hotspot = area.hotspots.find(hotspot => hotspot.documentId === area.area_type[0].hotspot_left.documentId)
			return (
				<Grid item xs={6} >
					<HotspotButton
					background={area?.background?.url}
					area={area.area_type[0]}
						 hotspot={hotspot}
						video_ref={hotspot.type[0].transition_in}
						side="left"
						isVisible={isVisible}
						canvas={canvas}
					/>
				</Grid>
			)
		}
	}
	const splitRight = (area) => {
		if (area.area_type[0].hotspot_right) {
			let hotspot = area.hotspots.find(hotspot => hotspot.documentId === area.area_type[0].hotspot_right.documentId)
			return (
				<Grid item xs={6} >
					<HotspotButton
					background={area?.background?.url}
					area={area.area_type[0]}
						hotspot={hotspot}
						video_ref={hotspot.type[0].transition_in}
						side="rigth"
						isVisible={isVisible}
						canvas={canvas}
					/>
				</Grid>
			);
		}
	}

	return (
		<>
			<PortraitAlert portrait={portrait} />
			<Box
				sx={{
					position: 'relative',
					display: 'grid',
					width: '100%',
					alignItems: 'center',
					overflow:'clip'
				}}
			>
				<AreaBackground
					firstLoad={firstLoad}
					setFirstLoad={setFirstLoad}
					area={area}
					video_ref={video_ref}
					handleVideoSnapshot={handleVideoSnapshot}
					canvas={canvas}
				/>
				{/* Floating corner UI elements */}
				{!portrait && (
					<Fade in={isVisible}>
						<Box>
							{/* Top left */}
							<Header details={area.area_type[0]} />
							{/* Top right */}
							<FilterBar />
							<FloatingResources fixed={false} />
							{/* Bottom right */}
							<LanguageSelect />
							{/* Bottom left */}
							<OverviewButtons />
						</Box>
					</Fade>
				)}
				{area.Logo?.url &&
					<Fade in={isVisible} timeout={{ enter: 1000, exit: 1000 }}>
						<Grid
							container
							direction="row"
							justifyContent="center"
							sx={{
								zIndex: 0,
								position: 'absolute',
								height: '300px',
								width: '100%',
								background: 'linear-gradient(to bottom, rgba(255,255,255,0.7) 20%,rgba(255,255,255,0) 100%)',
								top: 0,
								paddingTop: xlDown ? '1em' : '2em',
							}}
						>
							<Grid item >
								<img
									style={{
										height:'10vh'
									}}
									alt="certis"
								src={area.Logo.url}
								/>
							</Grid>
						</Grid>
					</Fade>
				}
				{area.area_type[0].__component === 'area.slider' &&
					<Fade in={isVisible} timeout={{ enter: 1000, exit: 1000 }}>
						<Box sx={{
							position: 'absolute',
							top: '50%',
							left: '50%',
							background: '#fff',
							transform: 'translate(-50%,-50%)',
							maxWidth: '700px'
						}}>
							<Grid item container >
								{splitLeft(area)}
								{splitRight(area)}
							</Grid>
						</Box>
					</Fade>
				}
				{//This is the timeline section 
					area.area_type[0].__component === 'area.timeline' &&
					<Fade in={isVisible} timeout={{ enter: 1000, exit: 1000 }}>
						<Box>
							<Timeline
								canvas={canvas}
								area={area}
							/>
						</Box>
					</Fade>
				}
				{/*If this section is split screen  don't show the hotspots*/}
				{(!portrait && !transition.play && area.area_type[0].__component !== 'area.slider') && area?.hotspots &&
					area.hotspots.map(hotspot => {
						return (
							<Hotspot
								key={hotspot.documentId}
								hotspot={hotspot}
								video_ref={video_ref}
								area={area}
								canvas={canvas}// added so we can set Canvas on hotspot 
							/>
						)
					})}
				{
					area.floating_buttons?.length > 0 && !portrait && (
						<FloatingCustom fixed={fixed} fabDetails={area.floating_buttons} />
					)
				}
			</Box >
		</>
	);
}
);

export default Area;
